module.exports = __webpack_public_path__ + "static/media/clipbardplus_grey.43c85cb4.svg";